import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Cortes",
    items: [
      { label: "Ordenes de Corte",          icon: "fas fa-file-alt", href: "/ListadoOrdenesCorte",         perm: "menu_produccion" },
      { label: "Cortes",                    icon: "fas fa-cut",      href: "/ListadoCortes",               perm: "menu_produccion" },
      { label: "Procesos Pendientes Recibir", icon: "fas fa-cut",    href: "/CortesPendientesRecibir",     perm: "menu_produccion" },
      { label: "Cortes Pendientes Habilitación", icon: "fas fa-tags", href: "/CortesPendientesHabilitacion", perm: "menu_produccion" },
    ],
  },
  {
    title: "Almacén y reportes",
    items: [
      { label: "Apartados",            icon: "fas fa-people-carry",     href: "/ListadoApartados",       perm: "menu_produccion"     },
      { label: "Reporte Cortes",       icon: "fas fa-cut",              href: "/ListadoArticulosCortes", perm: "menu_produccion"     },
      { label: "Reporte Costos Cortes", icon: "fas fa-dollar-sign",     href: "/ReporteCostosCortes",    perm: "reporteCostosCortes" },
      { label: "Entradas Almacén",     icon: "fas fa-right-to-bracket", href: "/ListadoEntradasAlmacen", perm: "menu_produccion"     },
    ],
  },
];

function BotonesProduccion() {
  return (
    <MenuGrid
      title="Producción"
      subtitle="Órdenes de corte, cortes, apartados y entradas a almacén"
      icon="fas fa-cut"
      accent={{ color: "#8b5cf6", bg: "#f5f3ff" }}
      gate="menu_produccion"
      sections={SECTIONS}
    />
  );
}

export default BotonesProduccion;
